<template>
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }, { name: '応募者メッセージテンプレート一覧', pathName: 'settingMessageTemplates' }]"
        :title="'応募者メッセージテンプレート'+formTypeLabel"
        data-test="title"
      />
      <div>
        <div class="boss-scout-send-container">
          <form-item
            v-model="name"
            :tag="confirm ? 'label' : 'input'"
            :type="confirm ? '' : 'text'"
          >
            <template slot="label">
              <span class="medium-2 cell pega-form-label">テンプレート名<small>（50文字以内）</small></span>
            </template>
          </form-item>
          <form-item
            v-model="subject"
            :tag="confirm ? 'label' : 'input'"
            :type="confirm ? '' : 'text'"
          >
            <template slot="label">
              <span class="medium-2 cell pega-form-label">件名<small>（200文字以内）</small></span>
            </template>
          </form-item>
          <form-textarea
            ref="message"
            v-model="body"
            :class-name="'boss-send-textarea'"
            :confirm="confirm"
          >
            <template slot="label">
              <span class="medium-2 cell pega-form-label">本文<small>（12000文字以内）</small></span>
            </template>
            <template v-if="!confirm">
              <template slot="header">
                <div class="padding-bottom-1">
                  <button
                    class="boss-button"
                    data-test="user-name"
                    @click="insertionValue('■USER_NAME■ 様')"
                  >
                    応募者名を挿入
                  </button>
                  <button
                    class="boss-button"
                    data-test="job-name"
                    @click="insertionValue('■JOB_NAME■')"
                  >
                    求人名を挿入
                  </button>
                  <button
                    class="boss-button"
                    data-test="company-name"
                    @click="insertionValue(currentUser.companyName)"
                  >
                    社名を挿入
                  </button>
                </div>
              </template>
            </template>
          </form-textarea>
        </div>
      </div>
      <div class="boss-layout boss-layout-center margin-bottom-1">
        <template v-if="confirm">
          <button class="boss-button boss-button-return">
            <span
              class="boss-button-return-text"
              data-test="history-back"
              @click="$router.back()"
            >戻る</span>
          </button>
        </template>
        <template v-else>
          <button
            :disabled="isConfirmButtonDisabled"
            data-test="sent-confirmation"
            class="boss-button boss-button-confirm pega-button"
            @click="submit"
          >
            <span
              class="boss-button-confirm-text"
              data-test="submit"
            >この内容でテンプレートを{{ formTypeLabel }}する</span>
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import FormItem from '../../components/atoms/FormItem'
import FormTextarea from '../../components/atoms/FormTextarea'
import { mapGetters } from 'vuex'

export default {
  components: {
    SettingHeader,
    FormItem,
    FormTextarea
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    confirm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      name: '',
      subject: '',
      body: ''
    }
  },
  computed: {
    isOverLengthSubject () {
      return this.subject.length > 100
    },
    isOverLengthBody () {
      return this.body.length > 10000
    },
    isOverLengthName () {
      return this.name.length > 25
    },
    isEmptySubject () {
      return this.subject.trim().length === 0
    },
    isEmptyBody () {
      return this.body.trim().length === 0
    },
    isEmptyName () {
      return this.name.trim().length === 0
    },
    isConfirmButtonDisabled () {
      return this.isEmptySubject ||
        this.isEmptyBody ||
        this.isEmptyName
    },
    ...mapGetters({
      currentUser: 'currentUser'
    }),
    formTypeLabel () {
      return this.id ? '編集' : '登録'
    }
  },
  created () {
    if (this.id) {
      this.$http.secured.get(`company/entry/message/templates/${this.id}`)
        .then(response => {
          this.name = response.data.name
          this.subject = response.data.subject
          this.body = response.data.body
        })
    } else {
      this.name = '新規テンプレート'
    }
  },
  methods: {
    insertionValue (value) {
      const cursorPosition = this.$refs.message.selectionStart
      this.body = this.body.substr(0, cursorPosition) + value + this.body.substr(cursorPosition, this.body.length)
    },
    submit () {
      this.$emit('submit', this.name, this.subject, this.body)
    }
  }
}
</script>
